module.exports = "<!-- <img ng-src=\"{{facilityMapCtrl.map.url}}\" alt=\"{{'FACILITY_MAP' | translate}}\" class=\"facility-map__image\"> -->\n\n<div class=\"am4-facility-map__name\">{{facilityMapCtrl.map.name}}</div>\n<div class=\"am4-facility-map__description\">{{facilityMapCtrl.map.description}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/facilityMap.html
// module id = 389
// module chunks = 14